<template>
  <div
    id="vipCard"
    :style="'height:' + window_.bodyH + 'px;overflow-y:auto;'"
  >
    <headNav
      color="#56AC9A"
      :home="true"
    />
    <div
      class="cell-container"
      :style="'height:' + window_.head_h + 'px;'"
    >
      <div
        class="cell-container_bg"
        :style="'height:' + window_.cell_bg_h + 'px;'"
      ></div>
      <div class="cell-container_box">
        <div class="cell-card">
          <van-image
            class="cell-card-img"
            radius="10px"
            :src="info_obj.data.levelImgUrl ? info_obj.data.levelImgUrl : info_obj.data.brandImgUrl"
            alt
          >
            <template v-slot:loading>
              <van-loading
                type="spinner"
                size="20"
              />
            </template>
            <template v-slot:error>
              <img src="../../assets/icon/default.png" />
            </template>
          </van-image>
        </div>
        <div
          class="cell-box_bg"
          style="top: 104px;height: 76px;border-radius: 50%;"
        ></div>
        <div
          class="cell-box"
          style="top:133px;box-shadow: 0vw 40px 20vw -40px #b4b4b4, 0px 40px 40px -20vw #b4b4b4, 0 0 0vw 0px #b4b4b4, 0vw 40px 20vw -40px #b4b4b4;"
        >
          <!-- 右側會員信息 -->
          <div class="cell-title">
            <div
              v-html="info_obj.data.levelName1"
              class="cell-status"
            ></div>
            <div class="cell-date">
              <span v-if="info_obj.data3.menberUpgradeDate">{{ info_obj.data3.menberUpgradeDate }}</span>
              <span v-if="info_obj.data3.menberUpgradeDate && info_obj.data3.endDate">-</span>
              <span v-if="info_obj.data3.endDate">{{ info_obj.data3.endDate }}</span>
            </div>
          </div>
          <!-- 會員升級區域 -->
          <div
            class="cell-level-box"
            v-show="init_Height()"
          >
            <!-- 舊等級 -->
            <div class="cell-level">
              <img
                src="../../assets/huiyuan.png"
                alt
              />
              <!-- <p class="cell-text">LV1</p> -->
            </div>
            <!-- 進度條 -->
            <div class="cell-progress">
              <!-- 當前值 -->
              <van-progress
                color="#c9af7c"
                pivot-color="#c9af7c"
                :show-pivot="true"
                :percentage="(info_obj.data1.nowPrice / info_obj.data3.countPrice) * 100 ? (info_obj.data1.nowPrice / info_obj.data3.countPrice) * 100 : 0"
                :pivot-text="String(info_obj.data1.nowPrice)"
                stroke-width="5"
                style="height: 6px;;"
              />
              <!-- 比值 -->
              <div
                class="cell-rate"
                v-text="info_obj.data1.nowPrice + '/' + info_obj.data3.countPrice"
              ></div>
            </div>
            <!-- 新等級 -->
            <div class="cell-level">
              <img
                src="../../assets/huiyuan2.png"
                alt
              />
              <!-- <p class="cell-text cell-text2">LV2</p> -->
            </div>
          </div>
          <!-- 提示 -->
          <van-notice-bar
            v-if="info_obj.data.levelDesc"
            class="cell-hint"
            background="#fff"
            color="#c9af7c"
            :text="info_obj.data.levelDesc"
          />
          <!-- 積分,優惠券 -->
          <div class="cell-section">
            <div
              @click="goIntegral"
              class="cell-div"
            >
              <img
                src="../../assets/jifen.png"
                alt
              />
              <p>
                {{ window_c['There are 2'] }}&nbsp;
                <span v-text="info_obj.data.consumePoints"></span>
                &nbsp;{{ window_c['points'] }}
              </p>
            </div>
            <div class="cell-line"></div>
            <div
              @click="goCoupon"
              class="cell-div"
            >
              <img
                src="../../assets/youhuiquan.png"
                alt
              />
              <p>
                {{ window_c['There are 1'] }}&nbsp;
                <span v-text="info_obj.data.couponCount"></span>
                &nbsp;{{ window_c['coupons'] }}
              </p>
            </div>
          </div>
          <!-- <img
						src="../../assets/icon/qrcode@2x.png"
						class="qrcode_min"
						@click="window_.qrcodeShow = true"
						style="width: 71px;height: 71px;top: 5px;right: 30px;border-radius: 5px;"
					/> -->
          <img
            v-if="window_.qrcodeImg"
            :src="window_.qrcodeImg"
            class="qrcode_min"
            @click="window_.qrcodeShow = true"
            style="width: 71px;height: 71px;top: 5px;right: 30px;border-radius: 5px;"
          />
          <div
            v-else
            class="qrcode_min"
            id="qrcode_min"
            @click="window_.qrcodeShow = true"
            style="width: 100px;height: 100px;top: -20px;left: 30px;padding: 4px;"
          ></div>
        </div>
      </div>
    </div>
    <!-- 輪播 -->
    <div class="cell-swiper-box">
      <van-swipe
        :loop="false"
        :width="swiperOption.width"
        :height="swiperOption.heigth"
        :show-indicators="false"
      >
        <van-swipe-item
          style="padding-left: 20px;"
          v-for="(item, index) in swiperList"
          :key="index"
        >
          <div
            class="cell-item"
            @click="goAd(item.id)"
          >
            <van-image
              class="cell_swiper_img"
              fit="cover"
              style="width:100%;height:100%;"
              radius="10px"
              :src="item.adImage"
            >
              <template v-slot:loading>
                <van-loading
                  type="spinner"
                  size="20"
                />
              </template>
              <template v-slot:error>
                <img
                  src="../../assets/icon/default.png"
                  style="width:100%;height:100%;border-radius: 10px;"
                />
              </template>
            </van-image>
            <div class="cell_swiper_text_mask ell1">{{ item.adTitle }}</div>
            <p
              class="cell_swiper_text ell1"
              v-text="item.adTitle"
            ></p>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div
      class="qrcodeMax_box"
      v-show="window_.qrcodeShow"
    >
      <van-overlay
        :show="window_.qrcodeShow"
        @click="window_.qrcodeShow = false"
      />
      <div
        class="qr_box_b"
        :style="'width:' + window_.qrcodeW + 'px;height:' + window_.qrcodeW + 'px;'"
      >
        <img
          v-if="window_.qrcodeImg"
          :src="window_.qrcodeImg"
          class="qrcode_max"
          :style="'width:' + window_.qrcodeW + 'px;height:' + window_.qrcodeW + 'px;'"
          style="padding: 4px;"
        />
        <div
          v-else
          id="qrcode_max"
          class="qrcode_max"
          :style="'width:' + window_.qrcodeW + 'px;height:' + window_.qrcodeW + 'px;'"
          style="padding: 4px;"
        ></div>
        <img
          src="../../assets/icon/icon_close.png"
          @click="window_.qrcodeShow = false"
          style="width:50px;height:50px;bottom: -60px;"
        />
      </div>
    </div>
  </div>
</template>
<script>
import headNav from '@/components/headNav';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { getMemberInfoOth, getQuickMark } from '@/js/api';
import util from '@/js/util.js';
import QRCode from 'qrcodejs2';
import lang_ from '@/js/locales';
export default {
  data () {
    return {
      window_: {
        bodyH: window.innerHeight - 46,
        qrcodeShow: false,
        qrcodeW: 0,
        qrcodeImg: '',
        cell_bg_h: 0,
        head_h: 0
      },
      window_c: {
        'There are 1': '優惠券',
        coupons: '張',
        'There are 2': '積分',
        points: '分'
      },
      swiperList: [],
      info_obj: {
        data: {
          levelName1: '普通會員',
          consumePoints: 0,
          couponCount: 0,
          levelDesc: '',
          brandImgUrl: ''
        },
        data1: {
          nowPrice: 1
        },
        data2: {},
        data3: {
          countPrices: 0,
          countPrice: 1,
          menberUpgradeDate: '2019-01-01',
          endDate: '2019-02-02'
        },
        data4: {}
      },
      swiperOption: {
        slidesPerView: 2, // 一行顯示幾個
        centeredSlides: true, // 默认active slide居左，设置为true后居中
        spaceBetween: 20, // 輪播之間的間距
        slideToClickedSlide: true, // 點擊會居中
        width: 0,
        heigth: 0
      }
    };
  },
  created () {
    util.selfSetIcon() // 設置logo
    this.getMemberInfo();
    this.getQuickMark_();
    this.window_.qrcodeW = window.innerWidth / 1.5;
    this.window_.cell_bg_h = window.innerWidth / 1.65;
    this.swiperOption.width = window.innerWidth * 0.8;
    this.swiperOption.heigth = (window.innerWidth * 0.8) / 2;
    this.window_.head_h = (window.innerWidth * 0.9) / 1.2 + 133;

    // console.log(lang_.t('bindSuccess'));
  },
  mounted () {
    // this.canvasQrcode('123456');
    var self = this;
    this.init_lang();
    setTimeout(function () {
      self.window_.head_h = document.getElementsByClassName('cell-box')[0].clientHeight + 143;
    }, 500);
  },
  methods: {
    init_lang () {
      var window_c = this.window_c;
      window_c['There are 1'] = lang_.t('There are 1');
      window_c['coupons'] = lang_.t('coupons');
      window_c['There are 2'] = lang_.t('There are 2');
      window_c['points'] = lang_.t('points');
    },
    goIntegral () {
      this.$router.push({
        path: '/integral/' + this.info_obj.data.consumePoints
      });
    },
    goCoupon () {
      this.$router.push({
        path: '/my_coupon'
      });
    },
    goAd (e) {
      console.log(e);
      this.$router.push({
        path: '/ad/' + e
      });
    },
    getMemberInfo () {
      var self = this;
      let userInfoStr = util.userInfo.get(this);
      if (userInfoStr) {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '加載中....'
        });
        var userinfo = JSON.parse(userInfoStr);
        var data = {
          brandId: util.getBrandId(this),
          memberId: userinfo.memberId,
          phone: userinfo.phone
        };
        getMemberInfoOth(data).then(res => {
          console.log(res);
          self.$toast.clear();
          if (res.code == '1') {
            this.swiperList = res.data.advertisement;
            for (const key in this.info_obj) {
              this.info_obj[key] = res[key];
            }
          }
        });
      }
    },
    getQuickMark_ () {
      var self = this;
      let userInfoStr = util.userInfo.get(this);
      if (userInfoStr) {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '加載中....'
        });
        var userinfo = JSON.parse(userInfoStr);
        var data = {
          memberId: userinfo.memberId,
          type: 1
        };
        getQuickMark(data).then(res => {
          self.$toast.clear();
          if (res.code == 1) {
            if (res.quickMark) {
              self.window_.qrcodeImg = res.quickMark;
            } else {
              self.canvasQrcode(res.qrcode);
            }
          }
        });
      }
    },
    errorImg (img) {
      return util.errorImg(img);
    },
    canvasQrcode (val) {
      var self = this;
      new QRCode('qrcode_min', {
        width: 90,
        height: 90,
        text: val, //表示内容，可以是地址或者是文字'55566'或者参数
        colorDark: '#000000', //前景色
        colorLight: '#ffffff' //背景色
      });

      new QRCode('qrcode_max', {
        width: self.window_.qrcodeW - 10,
        height: self.window_.qrcodeW - 10,
        text: val, //表示内容，可以是地址或者是文字'55566'或者参数
        colorDark: '#000000', //前景色
        colorLight: '#ffffff' //背景色
      });
    },
    init_Height () {
      var self = this;
      // if (this.info_obj.data1.nowPrice >= this.info_obj.data3.countPrice) {
      // 	self.window_.head_h = document.getElementsByClassName('cell-box')[0].clientHeight + 143 - document.getElementsByClassName('cell-level-box')[0].clientHeight;
      // 	return true;
      // }
      return true;
    }
  },
  components: {
    headNav,
    swiper,
    swiperSlide
  }
};
</script>
<style lang="" scoped>
#vipCard span.van-progress__pivot {
  top: -250%;
}
#app #vipCard .van-nav-bar {
  background-color: #5abba7;
}
#vipCard .van-progress__pivot {
  padding: 0 10px;
}
</style>
<style scoped>
#vipCard {
  padding-top: 80px;
  background-color: #fff;
}
.cell-container {
  /* background: linear-gradient(#c1a06a, #c1a06a, #e8e8e8, #e8e8e8); */
  position: relative;
  /* padding:30px 0; */
  padding: 40px 0 200px;
  padding-top: 0;
}

.cell-container_bg {
  /* background-image: linear-gradient(to right, rgba(182, 150, 110, 1), rgba(215, 193, 155, 1)); */
  background-image: linear-gradient(to right, #717171, #d4d4d4);
  width: 100%;
  position: absolute;
}

.cell-container_box {
  position: relative;
  padding-top: 40px;
}

.cell-card {
  width: 80%;
  margin: 0 auto;
  height: 560px;
  z-index: 2;
  position: relative;
  border-radius: 50px 50px 0 0;
  /* box-shadow: 0 0 20px #888; */
}
.cell-card-img {
  /* border-radius: 50px 50px 0 0; */
  width: 100%;
}
.cell-box {
  position: absolute;
  top: 260px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  background-color: #fff;
  z-index: 2;
  /* box-shadow: 0px 26px 25px #888; */
  padding: 80px 15px 30px;
  border-radius: 0 0 10px 10px;
  background: url("../../assets/bg_02.png") no-repeat center center;
  background-size: 100% 100%;
  /* box-shadow: -2px 2px 2vw 2px #b4b4b4; */
}

.cell-box_bg {
  position: absolute;
  top: 260px;
  left: 50%;
  transform: translateX(-50%);
  width: 89%;
  z-index: 1;
  background-color: rgb(135, 134, 134);
}

.cell-title {
  /* text-align: right; */
  margin-bottom: 30px;
}
.cell-status {
  background-image: -webkit-linear-gradient(bottom, #9e834c, #b69d6b, #cbbd9e);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 10px;
  font-size: 32px;
}
.cell-date {
  color: #999;
  font-size: 24px;
}
.cell-level-box {
  display: flex;
  /* align-items: flex-start; */
  align-items: center;
  margin-bottom: 10px;
}
.cell-progress {
  position: relative;
  flex: 1;
  margin: 0 10px;
  padding-top: 50px;
  /* box-sizing: border-box; */
}
.cell-present {
  text-align: center;
  display: inline-block;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #e2e2e2;
  border-radius: 15px;
  background-image: -webkit-linear-gradient(bottom, #9e834c, #b69d6b, #cbbd9e);
  margin-bottom: 10px;
  /* margin-bottom: 6px; */
}
.cell-rate {
  margin-top: 10px;
  font-size: 20px;
  color: #666;
  text-align: right;
}
.cell-level {
  text-align: center;
}
.cell-level img {
  width: 50px;
  height: 40px;
  margin-bottom: -5px;
}
.cell-text {
  color: #fff;
  background-image: -webkit-linear-gradient(bottom, #9e834c, #b69d6b, #cbbd9e);
  font-size: 16px;
  line-height: 1.3;
  border-radius: 5px;
  letter-spacing: 2px;
  padding: 0 3px;
}
.cell-text2 {
  background-image: none;
  background-color: #e2e2e2;
}
.cell-hint {
  font-size: 24px;
}
.cell-section {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cell-div {
  flex: 1;
  text-align: center;
}
.cell-div img {
  width: 56px;
  height: 56px;
}
.cell-div p {
  font-size: 24px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cell-div span {
  font-size: 30px;
  color: red;
}
.cell-line {
  height: 60px;
  border-right: 1px solid #ccc;
}
.cell-swiper-box {
  padding: 20px 0;
  position: relative;
  z-index: 3;
  background-color: #fff;
  margin-top: 2.5vw;
}

.cell-swiper-box swiper {
  padding-bottom: 5px;
}

.cell-swiper {
  width: 100%;
  display: flex;
  background-color: #fff;
  padding: 30px;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
.cell-swiper::-webkit-scrollbar {
  display: none;
}
.cell-item {
  position: relative;
  border-radius: 20px;
  box-shadow: 0 0 8px #c9af7c;
  background: url() no-repeat center center;
  background-size: cover;
  width: 100%;
  height: 100%;
}

.cell_swiper_text_mask {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  font-size: 24px;
  border-radius: 0 0 20px 20px;
  padding: 18px 0 18px 6px;
  background-color: rgba(183, 151, 97, 0.8);
  opacity: 0.5;
}
.cell_swiper_text {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  font-size: 24px;
  color: #fff;
  padding: 18px 0 18px 6px;
}
.cell-adTitle {
  position: absolute;
  width: 60%;
  bottom: 0;
  left: 0;
  padding: 30px 0 30px 20px;
}

.cell_swiper_img {
  width: 100%;
  height: 100%;
  border-radius: 20px;
}

.qrcode_min {
  position: absolute;
  /* background-color: #fff; */
  /* border: 1px solid #979797; */
}

.qrcodeMax_box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
}

.qr_box_b {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
}

.qrcodeMax_box img {
  position: absolute;
  z-index: 3;
}

.qrcode_max {
  position: absolute;
  background-color: #fff;
  border: 1px solid #979797;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/view/vipCard/menu.vue